/* 
Dependencies and firebase imports
*/
import * as service from "../../../Service/AreaBranchTeam.service";
import { mapGetters } from "vuex";
import DateFilter from "../../DateFilterComponent/DateFilter";
import GroupBy from "../../GroupByComponent/GroupBy";

// import { toasterColor, toasterModel } from "../../../Models/ToasterModel";

export default {
  name: "toolbar",
  components: {
    DateFilter,
    GroupBy,
  },
  data() {
    return {
      areaTeamBranchList: [],
      teams: [],
      branches: [],
      selectedArea: {},
      selectedTeam: {},
      selectedBranch: {},
      isLoadingFirstTime: true,
    };
  },
  computed: {
    showAreaDropdown() {
      if (this.areaTeamBranchList.length > 1) {
        return true;
      }
      return false;
    },
    showTeamDropDown() {
      if (this.areaTeamBranchList.length < 1) return false;
      if (this.areaTeamBranchList.length == 1) {
        if (this.areaTeamBranchList[0].listTeams.length == 1) {
          return false;
        }
      }
      return true;
    },
    showOfficeDropDown() {
      if (this.areaTeamBranchList.length < 1) return false;
      if (this.areaTeamBranchList.length == 1) {
        if (this.areaTeamBranchList[0].listTeams.length == 1) {
          if (this.areaTeamBranchList[0].listTeams[0].listOffices.length == 1) {
            return false;
          }
        }
      }
      return true;
    },
    ...mapGetters([
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
      "getAllAreaTeamBranch",
      "getUserDetails",
      "getActiveReportMenu",
    ]),
  },
  async mounted() {},
  methods: {
    changeArea(selectedArea) {
      this.$store.dispatch("changeArea", selectedArea);
      this.teams = selectedArea.listTeams;
      if (this.teams.length > 0) {
        this.changeTeam(this.teams[0]);
      }
    },
    changeTeam(selectedTeam) {
      this.$store.dispatch("changeTeam", selectedTeam);
      this.branches = selectedTeam.listOffices;
      if (this.branches.length > 0) {
        this.changeBranch(this.branches[0]);
      }
    },
    changeBranch(selectedBranch) {
      this.$store.dispatch("changeBranch", selectedBranch);
    },
    getDefaultArea() {
      var defaultArea = this.getAllAreaTeamBranch.filter(
        (x) => x.Area == this.getUserDetails.area
      );

      if (defaultArea.length > 0) {
        return defaultArea[0];
      }
      return this.getAllAreaTeamBranch[0];
    },
    getDefaultTeam(selectedArea) {
      var defaultTeam = selectedArea.listTeams.filter(
        (x) => x.Team == this.getUserDetails.team
      );

      if (defaultTeam.length > 0) {
        return defaultTeam[0];
      }
      return selectedArea.listTeams[0];
    },
    getDefaultOffice(selectedTeam) {
      var defaultOffice = selectedTeam.listOffices.filter(
        (x) => x.Office == this.getUserDetails.office
      );
      if (defaultOffice.length > 0) {
        return defaultOffice[0];
      }
      return selectedTeam.listOffices[0];
    },
  },
  watch: {
    getSelectedArea(newValue, oldValue) {
      this.selectedArea = newValue;
    },
    getSelectedTeam(newValue, oldValue) {
      this.selectedTeam = newValue;
    },
    getSelectedBranch(newValue, oldValue) {
      this.selectedBranch = newValue;
    },
    getAllAreaTeamBranch(newValue, oldValue) {
      this.areaTeamBranchList = newValue;
      if (newValue.length < 1) {
        return false;
      }

      if (this.isLoadingFirstTime) {
        var defaultArea = this.getDefaultArea();
        this.changeArea(defaultArea);
        var defaultTeam = this.getDefaultTeam(defaultArea);
        this.changeTeam(defaultTeam);
        this.changeBranch(this.getDefaultOffice(defaultTeam));
        this.isLoadingFirstTime = false;
      }
    },
  },
};
